function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#29c07b;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(4 4)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M25.262,6.328A.739.739,0,0,0,26,5.59V2.639a.739.739,0,0,0-.738-.738H23.541V-.311a.739.739,0,0,0-.738-.738H19.852a.739.739,0,0,0-.738.738V1.9H17.639v-4.18A1.723,1.723,0,0,0,15.918-4H6.082A1.723,1.723,0,0,0,4.361-2.279V1.9H2.885V-.311a.739.739,0,0,0-.738-.738H-.8a.739.739,0,0,0-.738.738V1.9H-3.262A.739.739,0,0,0-4,2.639V5.59a.739.739,0,0,0,.738.738h.246V21.574h-.246A.739.739,0,0,0-4,22.311v2.951A.739.739,0,0,0-3.262,26H25.262A.739.739,0,0,0,26,25.262V22.311a.739.739,0,0,0-.738-.738h-.246V6.328ZM-.066,1.9V.426H1.41V1.9ZM14.2-.557V1.9H7.8V-.557Zm.738-1.475H7.066a.739.739,0,0,0-.738.738V1.9H5.836v-4.18a.246.246,0,0,1,.246-.246h9.836a.246.246,0,0,1,.246.246V1.9h-.492V-1.3A.739.739,0,0,0,14.934-2.033ZM20.59,1.9V.426h1.475V1.9Zm2.951,4.426V21.574H-1.541V6.328ZM-2.525,4.852V3.377H24.525V4.852Zm27.049,18.2v1.475H-2.525V23.049Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M156.738,180.37l2.508.03L158,185.354a.738.738,0,0,0,1.237.7l6.885-6.885a.738.738,0,0,0-.521-1.259h-2.5l1.246-4.986a.738.738,0,0,0-.538-.894.741.741,0,0,0-.7.194l-6.885,6.885a.738.738,0,0,0,.515,1.259Zm5.243-1a.737.737,0,0,0,.173.021h1.662l-3.736,3.736.823-3.267a.738.738,0,0,0-.707-.918l-1.691-.02,3.764-3.764-.83,3.321A.738.738,0,0,0,161.981,179.366Z",
  transform: "translate(-150.171 -165.19)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M345.984,223.443h1.475v-.984h.984v-1.475h-.984V220h-1.475v.984H345v1.475h.984Z",
  transform: "translate(-327.545 -210.23)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 3.443,
  height: 1.475,
  transform: "translate(1.041 10.754)"
}));

var SvgBatteryVoltage = function SvgBatteryVoltage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBatteryVoltage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/battery-voltage.825f391c.svg";
export { ForwardRef as ReactComponent };